import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

export const useImportAppointmentMutation = (onSelect: (id: string) => void) => {
  const { selectedLocation } = useSelectedLocation();

  return useTypedMutation<string, string>({
    mutationFn: async dms_nr =>
      (await ApiInstance.post("/appointments/import", { dealer_location_id: selectedLocation?.id, dms_nr }, ENV.dmsAccessorBaseURL)).data.appointment_id,
    onSuccess: (_dms_nr, appointmentId) => onSelect(appointmentId)
  });
};
